import { supabase } from './supabase';

export interface Departure {
  date: string;                       // 'YYYY-MM-DD' Europe/Amsterdam
  slot_start: string;                 // ISO instant
  time_of_day: string;                // 'HH:MM'
  room_id: string;
  room_name: string;
  location_id: string;
  location_name: string;
  experience_id: string;
  experience_name: string;
  // Capacity is per-room (max_capacity or override). Every row sharing
  // (room_id, slot_start) carries the same value.
  capacity: number;
  // Room-wide bookings — sums every experience's bookings in (room, slot).
  // Compare against `capacity` for the X/Y display, sold-out, etc.
  booked: number;
  // Subset of `booked` attributable to this row's experience. Drives the
  // per-experience chip breakdown.
  booked_in_experience: number;
  // Per-experience: number of distinct bookings (not seats) for this row.
  bookings_count: number;
  // Per-experience lifecycle breakdown.
  lifecycle_summary: Record<string, number>;
}

export interface CalendarFilter {
  experienceId?: string | null;
  locationId?: string | null;
}

export async function fetchDepartures(
  fromDate: string,
  toDate: string,
  filter: CalendarFilter = {},
): Promise<Departure[]> {
  const { data, error } = await supabase
    .schema('booking')
    .rpc('fn_calendar_departures', {
      p_from: fromDate,
      p_to: toDate,
      p_experience_id: filter.experienceId ?? null,
      p_location_id: filter.locationId ?? null,
    });
  if (error) throw error;
  if (!Array.isArray(data)) return [];
  return data as Departure[];
}
